export const CLINIC = {
  name: "The Sky Dental Wellness Centre",
  short: "Sky Dental",
  tagline: "A full spectrum of dental wellness, under one considered roof.",
};

export const TOOTH_COLORS = [
  "#FF5E00", "#00E5FF", "#FFD700", "#FF204E",
  "#9D00FF", "#2F6BFF", "#00FF66", "#B5651D",
];

export const DOCTORS = [
  {
    id: "srikar",
    name: "Dr. Srikar Yallapragada",
    degrees: "BDS, CCRP, FRCD",
    role: "Root Canal Specialist",
    accent: "#FF204E",
    image: "/assets/dr-srikar.jpeg",
    short:
      "Endodontic care built on precision — saving natural teeth through advanced, pain-managed root canal therapy.",
    bio: "Dr. Srikar Yallapragada is a dedicated endodontist whose practice centres on preserving the natural tooth wherever possible. With advanced training in root canal therapy and modern rotary endodontics, he combines meticulous diagnosis with a calm, reassuring chairside manner. His approach is defined by careful case planning, magnification-assisted precision and a commitment to virtually pain-free treatment — helping patients keep the teeth they were meant to keep. (Sample bio — final copy to be provided by the clinic.)",
  },
  {
    id: "shreya",
    name: "Dr. Sai Shreya Yallapragada",
    degrees: "BDS, MDS",
    role: "Periodontist & Implantologist",
    accent: "#00E5FF",
    image: "/assets/dr-shreya.jpeg",
    short:
      "Foundations first — specialist gum care and dental implants that restore both function and confidence.",
    bio: "Dr. Sai Shreya Yallapragada is a periodontist and implantologist focused on the foundations of a healthy smile — the gums and bone that support it. She offers comprehensive periodontal therapy, from non-surgical gum treatment to advanced surgical and regenerative procedures, alongside single and full-arch dental implant rehabilitation. Known for her gentle, detail-oriented care, she helps patients rebuild strong, stable and beautiful smiles that last. (Sample bio — final copy to be provided by the clinic.)",
  },
  {
    id: "bharghav",
    name: "Dr. Bharghav Rayala",
    degrees: "MDS (Orthodontics & Dentofacial Orthopaedics)",
    role: "Orthodontist & Clear Aligner Specialist",
    accent: "#FFD700",
    image: "/assets/dr-bharghav.jpeg",
    short:
      "Straighter, healthier smiles for every age — from clear aligners to comprehensive orthodontic care.",
    bio: "Dr. Bharghav Rayala, MDS (Orthodontics & Dentofacial Orthopaedics) is an Orthodontist and Clear Aligner Specialist with expertise in the diagnosis, prevention, and correction of dental and facial irregularities. He specializes in conventional braces, self-ligating braces, clear aligners, and comprehensive orthodontic treatment for patients of all age groups.\n\nKnown for his patient-centric approach and commitment to excellence, Dr. Bharghav combines modern orthodontic techniques with personalized treatment planning to achieve functional, healthy, and aesthetically pleasing smiles. He stays updated with the latest advancements in orthodontics to ensure the highest standards of care for his patients.",
  },
  {
    id: "divya",
    name: "Dr. Divya Sree Kommineni",
    degrees: "BDS, MDS (Pediatric & Preventive Dentistry)",
    role: "Pediatric Dentist",
    accent: "#00FF66",
    image: "/assets/dr-divya.png",
    short:
      "Gentle, joyful dentistry for infants, children and adolescents — where every visit builds lifelong habits.",
    bio: "Dr. Divya Sree Kommineni, BDS, MDS (Pediatric & Preventive Dentistry) is a dedicated pediatric dentist committed to providing gentle, compassionate, and evidence-based dental care for infants, children, adolescents, and children with special healthcare needs. She completed her BDS from Vishnu Dental College & Hospital, Bhimavaram, followed by her MDS in Pediatric & Preventive Dentistry from the prestigious Government Dental College & Hospital, Mumbai. She was also honored as the University Topper and Gold Medalist in Pediatric Dentistry by the Maharashtra University of Health Sciences, reflecting her commitment to excellence in academics and clinical practice.\n\nShe is passionate about preventive dentistry, behavior management, early intervention and minimally invasive treatment approaches. She believes that every child deserves a positive dental experience and strives to create a friendly, comfortable environment where young patients can build lifelong healthy oral habits. She works closely with parents to educate them on maintaining their child's oral health, ensuring every visit is informative, reassuring, and enjoyable.",
  },
];

export const SPECIALTIES = [
  {
    title: "Root Canal Therapy",
    desc: "Advanced, pain-managed endodontics to save and strengthen natural teeth.",
    accent: "#FF204E",
    span: "md:col-span-7",
  },
  {
    title: "Implants & Gum Care",
    desc: "Specialist periodontal treatment and single to full-arch dental implants.",
    accent: "#00E5FF",
    span: "md:col-span-5",
  },
  {
    title: "Orthodontics & Clear Aligners",
    desc: "Braces, self-ligating systems and invisible aligners for every age.",
    accent: "#FFD700",
    span: "md:col-span-5",
  },
  {
    title: "Pediatric Dentistry",
    desc: "Gentle, preventive and behaviour-guided care for growing smiles.",
    accent: "#00FF66",
    span: "md:col-span-7",
  },
];

export const GENERAL_SERVICES = [
  "Dental Check-up & Consultation",
  "Scaling & Teeth Cleaning",
  "Teeth Whitening",
  "Tooth-coloured Fillings",
  "Crowns & Bridges",
  "Dentures & Partials",
  "Tooth Extractions",
  "Wisdom Tooth Surgery",
  "Smile Design & Veneers",
  "Full Mouth Rehabilitation",
  "Digital X-rays & Diagnostics",
  "Kids' Preventive Care",
];

export const MARQUEE_ITEMS = [
  "Root Canals",
  "Dental Implants",
  "Clear Aligners",
  "Kids Dentistry",
  "Gum Care",
  "Smile Design",
  "Teeth Whitening",
  "Orthodontics",
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Precision",
    body: "Every treatment begins with meticulous diagnosis. We measure twice and treat once — because your natural teeth deserve nothing less than exactness.",
  },
  {
    no: "02",
    title: "Comfort",
    body: "Modern, pain-managed techniques and a calm environment. From anxious first-timers to the youngest patients, care here is gentle by design.",
  },
  {
    no: "03",
    title: "Wellness",
    body: "We treat mouths, not just teeth. Prevention, education and long-term oral health sit at the centre of everything we do across both units.",
  },
];

export const LOCATIONS = [
  {
    unit: "Unit 01",
    area: "Boduppal",
    address:
      "Boduppal Colony Rd, Hema Nagar Colony, Hema Nagar, Boduppal, Hyderabad, Telangana 500039",
    phone: "07331120919",
    phoneDisplay: "+91 73311 20919",
    map: "https://maps.app.goo.gl/tZ8sWXnxPWM3EXEp9",
  },
  {
    unit: "Unit 02",
    area: "Saidabad",
    address:
      "Mahendarkars house, Saroornagar, Singareni Colony, Saroor Nagar West, Hyderabad, Telangana 500059",
    phone: "08977508487",
    phoneDisplay: "+91 89775 08487",
    map: "https://maps.app.goo.gl/mXp2JxHJgApbhr1v7",
  },
];
